/**
 * Next.js resolves environment mode from Node at build/runtime rather than
 * `import.meta.env`. Keep the shape identical to the legacy helper so shared
 * components can run unchanged during the migration.
 */
export default function getEnv() {
  const envMode = process.env.NODE_ENV ?? 'development';

  return {
    envMode,
    isDev: envMode === 'development',
    isProd: envMode === 'production',
  };
}
